import React from 'react';
import { volumes } from '../data/content';
export function VolumesSection() {
  return <section className="w-full bg-forest-800 px-6 py-20 sm:py-24" aria-labelledby="volumenes-titulo" data-id="element-193" data-mp="3uudx5tbejziq">
      <div className="mx-auto max-w-6xl" data-id="element-194" data-mp="cp10igkqt8ai">
        <div className="max-w-3xl" data-id="element-195" data-mp="cnzdreud6xcy">
          <span className="text-sm font-semibold text-ember-400" data-id="element-196" data-mp="7pelq2p9njzl">Los 6 Volúmenes del Kit</span>
          <h2 id="volumenes-titulo" className="mt-4 font-display text-3xl font-bold leading-tight text-cream-50 sm:text-4xl lg:text-[2.75rem]" data-id="element-197" data-mp="3g57qxle5d91c">
            Cobertura técnica integral de la automatización moderna
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-cream-100/70" data-id="element-198" data-mp="3pwlvw8ovb11v">
            6 volúmenes digitales con base científica, protocolos de laboratorio y diagramación técnica, listos
            para tu clase.
          </p>
        </div>

        <ol className="mt-14 grid gap-px overflow-hidden rounded-3xl bg-white/10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-199" data-mp="2sfn60wyfo1pf">
          {volumes.map(({
          icon: Icon,
          number,
          title,
          description
        }) => <li key={number} className="flex h-full flex-col bg-forest-800 p-7" data-id="element-200" data-mp="29do0hyc7fca6">
              <div className="flex items-center justify-between" data-id="element-201" data-mp="2ecqtgkewts1s">
                <Icon className="h-7 w-7 text-ember-400" aria-hidden="true" data-id="element-202" data-mp="2j6d09vye71po" />
                <span className="font-display text-3xl font-bold text-cream-100/20" data-id="element-203" data-mp="2o4wl1t1927gg">
                  {String(number).padStart(2, '0')}
                </span>
              </div>
              <h3 className="mt-6 font-display text-xl font-semibold leading-snug text-cream-50" data-id="element-204" data-mp="1vfpqt68tw410">
                Volumen {number}: {title}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-cream-100/65" data-id="element-205" data-mp="20d94o51m6esf">{description}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}